'use strict';

const Months = [
	'month00', 'month01', 'month02', 'month03',
	'month04', 'month05', 'month06', 'month07',
	'month08', 'month09', 'month10', 'month11',
	'month12'
];
const Day0 = 'day0';
const Day1 = 'day1';
const Day2 = 'day2';
const Day7 = 'day7';
const Day14 = 'day14';
const Day30 = 'day30';
const Days = [Day0, Day1, Day2, Day7, Day14, Day30];

const LifeIntervals = ['day0', ...Months, 'historic'];
const Day7Intervals = [Day1, Day2, Day7];
const Day14Intervals = [Day14];


export {Days, Months, LifeIntervals, Day7Intervals, Day14Intervals};